import React, { useState, useEffect } from 'react';
import { Card, Image } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { MENU_URL } from '../constants.js';

function FavoriteProducts({ favoriteProducts, addToCart, DeleteFromFavorites }) {
  const [favoriteProductsUser, setFavoriteProducts] = useState([]);

  useEffect(() => {
    fetch(MENU_URL)
      .then((res) => res.json())
      .then((data) => {
        const filteredProducts = data.filter((product) =>
          favoriteProducts.products.includes(product.id)
        );
        setFavoriteProducts(filteredProducts);
      });
  }, [favoriteProducts]);

  return (
    <div className="d-flex justify-content-center" style={{ height: '100vh' }}>
      <div className="container">
        <h1 className="text-center">Se dina favoriter!</h1>
        <div className="row">
          {favoriteProductsUser.map((product) => (
            <div className="col-12 col-sm-6 col-md-4 mb-3" key={product.id}>
              <Card
                style={{
                  width: '100%',
                  maxWidth: '18rem', // Limit the card width to prevent it from stretching too wide
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: '#6C757D',
                  color: '#fff',
                  borderRadius: '10px',
                }}
              >
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    backgroundColor: '#495057',
                    color: '#fff',
                    height: '200px', // Fixed height for the image container
                  }}
                >
                  <Image
                    className="mt-2"
                    src={`${product.image}`}
                    alt={product.title}
                    rounded
                    style={{
                      maxWidth: '80%',
                      maxHeight: '80%',
                      objectFit: 'contain',
                    }}
                  />
                </div>
                <Card.Body
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <Card.Title style={{ fontSize: '1rem' }}>{product.title}</Card.Title>
                  <Card.Text style={{ fontSize: '0.85rem' }}>{product.description}</Card.Text>
                  <div className="d-flex justify-content-between mt-auto">
                    <Button className="btn btn-success btn-sm" onClick={() => addToCart(product)}>
                      Lägg i varukorg
                    </Button>
                    <Button className="btn btn-danger btn-sm" onClick={() => DeleteFromFavorites(product)}>
                      Ta bort favorit
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FavoriteProducts;
